import { captureRef } from 'react-native-view-shot';

export default captureRef;
